export default __webpack_public_path__ + "atomic/_patterns/02-molecules/newsroom-teaser/_newsroom-teaser.twig";